import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from 'react';
import { SidebarProvider } from '../context/SidebarContext';

/**
 * Shared provider stack for app shell and tests (Sidebar + MUI date pickers).
 */
export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <SidebarProvider>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {children}
    </LocalizationProvider>
  </SidebarProvider>
);
